import { Link } from "react-router-dom";
import Icon from "../../../ui/icons/Icon";
import NavigateLink from "../../navigateLink/navigateLink";
import Scroll from "../../../ui/scroll/Scroll";
import iconsList from "../../../ui/icons/iconsList";
import classes from "../Widget.module.css";
const WidgetContent = ({ className = "", width, height, color, titleColor = "black", children, links = [], mainLink, title, icon, contentScrollable = true, scrollHeight, onClick }) => {

    return (
        <NavigateLink link={mainLink} showLoadingPage={false} onClick={onClick}>
            <div
                className={`${classes.Widget} ${className}`}
                style={{
                    background: color,
                    ...(width != null && { width }),
                    ...(height != null && { height }),
                }}
                onClick={onClick ? () => onClick() : undefined}
            >
                {title && (
                    <div className={classes.WidgetHeader}>
                        {icon && <Icon name={icon} size="26px" color={titleColor} />}
                        <span className={classes.WidgetTitle} style={{ color: titleColor }}>
                            {title}
                        </span>
                    </div>
                )}

                {contentScrollable ? (
                    <Scroll showDots={true} height={scrollHeight}>
                        <div className={classes.WidgetScrollContent}>
                            {children}
                        </div>
                    </Scroll>
                ) : (
                    <div className={classes.WidgetBody}>{children}</div>
                )}

                {links?.length > 0 && (
                    <div className={classes.LinksWrapper}>
                        {links.map((link, i) => (
                            <Link key={i} to={link.to} className={classes.WidgetLink} onClick={(e) => e.stopPropagation()}>
                                {link.text}
                            </Link>
                        ))}
                    </div>
                )}

                {mainLink &&
                    <div className={classes.ArrowsLink}>
                        <Icon name={iconsList.arrows} size="27px" color={titleColor} />
                    </div>
                }
            </div>
        </NavigateLink>
    );
};

export default WidgetContent;
